export enum AlertType {
  AgentHeartbeat = 1,
  ApplicationUnhealthy = 2,
  DiskUsage = 3,
  TaskNotRun = 4,
  CpuUsage = 5,
  RamUsage = 6,
  EStatement = 7,
}

export enum AlertSeverity {
  Low = 1,
  Medium = 2,
  High = 3,
  Critical = 4,
}

export enum AlertStatus {
  New = 1,
  Acknowledged = 2,
  Resolved = 3,
}

export interface AlertListResult {
  items: Alert[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface Alert {
  id: string;
  tenantId: string;
  tenantName: string;
  serverId?: string;
  serverName?: string;
  applicationDefinitionId?: string;
  applicationName?: string;
  alertType: AlertType;
  alertTypeName: string;
  severity: AlertSeverity;
  severityName: string;
  message: string;
  status: AlertStatus;
  statusName: string;
  acknowledgedAt?: string;
  acknowledgedBy?: string;
  acknowledgedByUserName?: string;
  resolvedAt?: string;
  resolvedBy?: string;
  resolvedByUserName?: string;
  resolutionNotes?: string;
  createdAt: string;
}



